/**
 * Desktop hover: open Shop <details> and sync section backdrop height.
 * Uses mouseout + relatedTarget so moving onto the mega panel still counts as “inside” the menu.
 */
(function () {
  const HOVER_MQ = window.matchMedia('(min-width: 990px) and (hover: hover)');

  function getSectionHeader() {
    return (
      document.querySelector('.shopify-section.section-header') ||
      document.querySelector('.header-wrapper')?.closest('.shopify-section')
    );
  }

  function clearShopHoverState(section) {
    if (!section) return;
    section.classList.remove('section-header--shop-hover-open');
    section.style.removeProperty('--shop-hover-stack-height');
    section.style.removeProperty('--shop-hover-section-bg');
  }

  function syncSectionBackground(section) {
    if (!section) return;
    /* Shop panel is always a light surface; do not mirror the header bar (often dark). */
    section.style.setProperty('--shop-hover-section-bg', '#ffffff');
  }

  function updateStackHeight(section, menu) {
    if (!section || !menu) return;
    const panel = menu.querySelector('[data-shop-hover-panel]');
    const details = menu.querySelector('details');
    if (!panel || !details || !details.open) {
      clearShopHoverState(section);
      return;
    }
    const measure = () => {
      if (!details.open) {
        clearShopHoverState(section);
        return;
      }
      syncSectionBackground(section);
      const secRect = section.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();
      const h = Math.ceil(panelRect.bottom - secRect.top);
      if (h > 0) {
        section.style.setProperty('--shop-hover-stack-height', `${h}px`);
        section.classList.add('section-header--shop-hover-open');
      }
    };
    window.requestAnimationFrame(() => {
      measure();
      window.requestAnimationFrame(measure);
    });
  }

  function bindShopPanelReflow(menu, details, sectionGetter) {
    const panel = menu.querySelector('[data-shop-hover-panel]');
    if (!panel || panel.dataset.shopStackBound) return;
    panel.dataset.shopStackBound = '1';
    panel.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'max-height' && e.propertyName !== 'padding-top' && e.propertyName !== 'padding-bottom')
        return;
      if (!HOVER_MQ.matches) return;
      if (!details.open) {
        clearShopHoverState(sectionGetter());
        return;
      }
      updateStackHeight(sectionGetter(), menu);
    });
  }

  const onResize = debounce(() => {
    const section = getSectionHeader();
    document.querySelectorAll('[data-header-shop-hover]').forEach((menu) => {
      const d = menu.querySelector('details');
      if (d && d.open && HOVER_MQ.matches) {
        updateStackHeight(section, menu);
      }
    });
    if (!HOVER_MQ.matches) {
      clearShopHoverState(section);
    }
  }, 120);

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function initMenu(menu) {
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    let closeTimer = null;
    const section = () => getSectionHeader();

    function openFromHover() {
      if (!HOVER_MQ.matches) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      updateStackHeight(section(), menu);
    }

    function scheduleClose() {
      if (!HOVER_MQ.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        clearShopHoverState(section());
      }, 120);
    }

    menu.addEventListener('mouseenter', openFromHover);

    menu.addEventListener('mouseout', (e) => {
      if (!HOVER_MQ.matches) return;
      const next = e.relatedTarget;
      if (next && menu.contains(next)) return;
      scheduleClose();
    });

    details.addEventListener('toggle', () => {
      if (!details.open) {
        clearShopHoverState(section());
        return;
      }
      if (HOVER_MQ.matches) {
        updateStackHeight(section(), menu);
      }
    });

    bindShopPanelReflow(menu, details, section);
  }

  function init() {
    document.querySelectorAll('[data-header-shop-hover]').forEach(initMenu);
    window.addEventListener('resize', onResize);
    HOVER_MQ.addEventListener('change', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
